(function () {
  var HERO_STORAGE = 'ge-playlist-hero';
  var DESKTOP_MQ = '(min-width: 990px)';

  function parseRgb(input) {
    if (!input) return null;
    var s = String(input).trim();
    var hex = s.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (hex) {
      var h = hex[1];
      if (h.length === 3) {
        h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      }
      return {
        r: parseInt(h.slice(0, 2), 16),
        g: parseInt(h.slice(2, 4), 16),
        b: parseInt(h.slice(4, 6), 16)
      };
    }
    var rgb = s.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i);
    if (rgb) {
      return { r: +rgb[1], g: +rgb[2], b: +rgb[3] };
    }
    return null;
  }

  function relativeLuminance(rgb) {
    function channel(c) {
      c = c / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * channel(rgb.r) + 0.7152 * channel(rgb.g) + 0.0722 * channel(rgb.b);
  }

  function hoistSurfaceTokens(root, mode) {
    var bg = getComputedStyle(root).getPropertyValue('--playlist-bg').trim();
    var fg = getComputedStyle(root).getPropertyValue('--playlist-fg').trim();
    if (bg) document.body.style.setProperty('--playlist-bg', bg);
    /*
      Media chrome only. Never hoist ink into --playlist-fg on light-shell
      modes — header icons use light chrome over banner/bleed media.
    */
    if (mode === 'banner' || mode === 'album') {
      document.body.style.setProperty('--playlist-fg', '#ffffff');
      return;
    }
    if (fg) document.body.style.setProperty('--playlist-fg', fg);
  }

  function applyAutoTone(root) {
    if (root.getAttribute('data-auto-tone') !== 'true') return;
    var mode = root.getAttribute('data-hero-mode') || 'bleed';
    /*
      Banner/album: hero overlay stays light; body ink is CSS-only.
      Do not rewrite --playlist-fg to ink (that darkened desktop header icons).
    */
    if (mode === 'banner' || mode === 'album') {
      root.setAttribute('data-tone', 'dark');
      root.style.setProperty('--playlist-fg', '#ffffff');
      document.body.style.setProperty('--playlist-fg', '#ffffff');
      return;
    }

    var bg =
      getComputedStyle(root).getPropertyValue('--playlist-bg').trim() ||
      getComputedStyle(root).backgroundColor;
    var rgb = parseRgb(bg);
    if (!rgb) return;
    var tone = relativeLuminance(rgb) > 0.55 ? 'light' : 'dark';
    root.setAttribute('data-tone', tone);
    if (tone === 'light') {
      var ink =
        getComputedStyle(document.documentElement).getPropertyValue('--ge-ink').trim() ||
        '#17160f';
      root.style.setProperty('--playlist-fg', ink);
      document.body.style.setProperty('--playlist-fg', ink);
    } else {
      var lightFg =
        getComputedStyle(root).getPropertyValue('--playlist-fg').trim() || '#ffffff';
      root.style.setProperty('--playlist-fg', lightFg);
      document.body.style.setProperty('--playlist-fg', lightFg);
    }
  }

  function readHeroOverride() {
    try {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('hero');
      if (q && /^(auto|album|banner|bleed)$/.test(q)) return q;
    } catch (e) {}
    if (window.localStorage) {
      try {
        var stored = window.localStorage.getItem(HERO_STORAGE);
        if (stored && /^(auto|album|banner|bleed)$/.test(stored)) return stored;
      } catch (e) {}
    }
    return null;
  }

  function resolveHeroMode(pref, hasVideo, isDesktop) {
    pref = pref || 'auto';
    if (pref === 'album' || pref === 'banner' || pref === 'bleed') return pref;
    // auto: mobile bleed; desktop always banner (ecom full-width → white canvas)
    if (!isDesktop) return 'bleed';
    return 'banner';
  }

  function applyHeroMode(root) {
    var hero = root.querySelector('[data-discover-hero]') || root;
    var pref = readHeroOverride() || root.getAttribute('data-hero-pref') || 'auto';
    var hasVideo = root.getAttribute('data-has-video') === 'true';
    var isDesktop = window.matchMedia(DESKTOP_MQ).matches;
    var mode = resolveHeroMode(pref, hasVideo, isDesktop);

    root.setAttribute('data-hero-mode', mode);
    root.setAttribute('data-hero-pref', pref);
    hero.setAttribute('data-hero-mode', mode);
    hero.setAttribute('data-hero-pref', pref);

    // Bleed paints the page; album/banner keep light shell.
    if (mode === 'bleed') {
      hoistSurfaceTokens(root, mode);
      document.body.classList.add('ge-hero-bleed');
      document.body.classList.remove('ge-hero-light-shell');
    } else {
      hoistSurfaceTokens(root, mode);
      document.body.classList.remove('ge-hero-bleed');
      document.body.classList.add('ge-hero-light-shell');
    }
  }

  function initDescClamp(root) {
    var wrap = root.querySelector('[data-playlist-desc]');
    if (!wrap) return;

    var body = wrap.querySelector('[data-playlist-desc-body]');
    var toggle = wrap.querySelector('[data-playlist-desc-toggle]');
    if (!body || !toggle) return;

    var labelMore = toggle.getAttribute('data-label-more') || 'More';
    var labelLess = toggle.getAttribute('data-label-less') || 'Less';

    function isTruncated() {
      return body.scrollHeight > body.clientHeight + 1;
    }

    function syncToggle() {
      var expanded = wrap.classList.contains('is-expanded');
      if (expanded) {
        toggle.hidden = false;
        toggle.textContent = labelLess;
        toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      var needsToggle = isTruncated();
      toggle.hidden = !needsToggle;
      toggle.textContent = labelMore;
      toggle.setAttribute('aria-expanded', 'false');
      wrap.classList.toggle('is-clamped', needsToggle);
    }

    function setExpanded(expanded) {
      wrap.classList.toggle('is-expanded', expanded);
      if (!expanded) wrap.classList.remove('is-clamped');
      syncToggle();
    }

    toggle.addEventListener('click', function () {
      setExpanded(!wrap.classList.contains('is-expanded'));
    });

    setExpanded(false);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        if (!wrap.classList.contains('is-expanded')) syncToggle();
      });
      ro.observe(body);
    }

    window.addEventListener('resize', function () {
      if (!wrap.classList.contains('is-expanded')) syncToggle();
    });
  }

  function initViews(root) {
    var buttons = root.querySelectorAll('[data-playlist-view]');
    var panels = root.querySelectorAll('[data-playlist-panel]');
    if (!buttons.length || !panels.length) return;

    var storageKey = 'ge-playlist-view';

    function setView(view, persist) {
      view = view === 'list' ? 'list' : 'grid';
      buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-playlist-view') === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-playlist-panel') === view;
        if (match) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      root.setAttribute('data-active-view', view);
      if (persist && window.localStorage) {
        try {
          window.localStorage.setItem(storageKey, view);
        } catch (e) {}
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-playlist-view') || 'grid', true);
      });
    });

    var preferred = null;
    if (window.localStorage) {
      try {
        preferred = window.localStorage.getItem(storageKey);
      } catch (e) {}
    }
    setView(preferred || root.getAttribute('data-default-view') || 'grid', false);
  }

  function init(root) {
    applyHeroMode(root);
    applyAutoTone(root);
    initDescClamp(root);
    initViews(root);

    var mq = window.matchMedia(DESKTOP_MQ);
    var onChange = function () {
      applyHeroMode(root);
      applyAutoTone(root);
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  document.querySelectorAll('[data-playlist-detail], [data-series-detail]').forEach(init);
})();
